module.exports = __webpack_public_path__ + "img/shopx1.7a93770b.png";